(() => {
const feUi = JSON.parse(document.getElementById('fe-landing-ui-strings')?.textContent || '{}');
(() => {
  if (customElements.get('fk-landing-section')) return;
  class FemiekoLanding extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (el, event, fn) => el?.addEventListener(event, fn, {signal});
      const tabs = [...this.querySelectorAll('[data-fk-tab]')];
      const panels = [...this.querySelectorAll('[data-fk-panel]')];
      if (tabs.length) {
        this.querySelector('.fk-lp__tabs').hidden = false;
        const activate = id => {tabs.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.fkTab === id)));panels.forEach(p => p.hidden = p.id !== id);};
        tabs.forEach(b => on(b, 'click', () => activate(b.dataset.fkTab)));
        on(this.closest('.shopify-section') || this, 'shopify:block:select', e => {const p = e.target.closest('[data-fk-panel]');if(p) activate(p.id);});
        activate(tabs[0].dataset.fkTab);
      }
      const hips = this.querySelector('[data-fk-hips]');
      if (hips) {
        this.querySelector('.fk-lp__size-controls').hidden = false;
        const waist = this.querySelector('[data-fk-waist]'), result = this.querySelector('[data-fk-size-result]');
        const update = () => {
          const value = Number(hips.value), w = Number(waist.value);
          if (!hips.value || !hips.validity.valid) {result.textContent = feUi.invalidSize;return;}
          const rows = [...this.querySelectorAll('[data-fk-size]')].filter(r => value >= Number(r.dataset.min) && value <= Number(r.dataset.max));
          if (!rows.length) {result.textContent = feUi.outsideSize;return;}
          result.textContent = (rows.length > 1 ? (feUi.betweenSizes + ' ') : (feUi.hipsSize + ' ')) + rows.map(r => r.dataset.fkSize).join((' ' + feUi.and + ' ')) + feUi.sizeAdvice;
          if (waist.value && (!waist.validity.valid || !rows.some(r => w >= Number(r.dataset.waistMin) && w <= Number(r.dataset.waistMax)))) result.textContent += (' ' + feUi.waistAdvice);
        };
        on(hips, 'input', update);on(waist, 'input', update);
      }

    }
    disconnectedCallback() {queueMicrotask(() => {if(!this.isConnected){this.controller?.abort();this.controller=null;}});}
  }
  customElements.define('fk-landing-section', FemiekoLanding);
})();

})();
